import { CardSection } from './CardSection';

export type { TypeCardSectionProps } from './types';
export default CardSection;
